import { useState } from 'react';

import {
  IconArrowNarrowLeft,
  IconArrowNarrowRight,
  IconCalendar,
} from '@pentabd/icons';
import { Text } from '@pentabd/ui';

export const DateFilter = () => {
  const today = new Date();
  const [currentDate, setCurrentDate] = useState(today);

  const handlePrevious = () => {
    const previousDate = new Date(currentDate);
    previousDate.setDate(previousDate.getDate() - 1);
    setCurrentDate(previousDate);
  };

  const handleNext = () => {
    if (currentDate.toDateString() === today.toDateString()) {
      return;
    }
    const nextDate = new Date(currentDate);
    nextDate.setDate(nextDate.getDate() + 1);
    setCurrentDate(nextDate);
  };

  return (
    <div className="btn btn-light-outline rounded-3 px-8 py-5 d-flex">
      <div className="d-flex align-items-center gap-4">
        <button onClick={handlePrevious} className="date-btn">
          <IconArrowNarrowLeft size={20} fill="subtitle2" />
        </button>
        <div className="px-10 d-flex align-items-center gap-4">
          <Text color="subtitle1" size="sm">
            {currentDate.toLocaleDateString('en-US', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            })}
          </Text>
          <IconCalendar size="20" fill="subtitle2" />
        </div>
        <button onClick={handleNext} className="date-btn">
          <IconArrowNarrowRight
            size={20}
            fill={
              currentDate.toDateString() === today.toDateString()
                ? 'subtitle3'
                : 'subtitle2'
            }
          />
        </button>
      </div>
    </div>
  );
};
